var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRefleshAltLinedDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.985 3.66016C16.214 3.66016 19.6725 7.20415 19.6725 11.6138C19.6725 16.0234 16.214 19.5674 11.985 19.5674C8.14587 19.5674 4.94314 16.6485 4.3838 12.8101C4.339 12.5027 4.05348 12.2898 3.74607 12.3346C3.43865 12.3794 3.22576 12.6649 3.27056 12.9723C3.90536 17.3286 7.55258 20.6924 11.985 20.6924C16.8687 20.6924 20.7975 16.6108 20.7975 11.6138C20.7975 6.61676 16.8687 2.53516 11.985 2.53516C8.36012 2.53516 5.25821 4.78733 3.90345 7.98808C3.78236 8.27417 3.91611 8.60425 4.2022 8.72534C4.48829 8.84643 4.81837 8.71268 4.93946 8.42659C6.13084 5.61187 8.8438 3.66016 11.985 3.66016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.10998 3.38675C3.79932 3.38675 3.54748 3.63859 3.54748 3.94925V7.75732C3.54748 8.3165 4.0008 8.76982 4.55998 8.76982H8.23498C8.54564 8.76982 8.79748 8.51798 8.79748 8.20732C8.79748 7.89666 8.54564 7.64482 8.23498 7.64482H4.67248V3.94925C4.67248 3.63859 4.42064 3.38675 4.10998 3.38675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRefleshAltLinedDownload);
export default __webpack_public_path__ + "static/media/ic_reflesh_alt_lined_download.15858ba2b6b6c19b6b4fb5960885ba55.svg";
export { ForwardRef as ReactComponent };